import React from "react";

import { Link as RouterLink } from "react-router-dom";

//MUI
import Typography from "@mui/material/Typography";
import Card from "@mui/material/Card";
import CardActionArea from "@mui/material/CardActionArea";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";

interface FarmerInfo {
  docId: string;
  name: string;
  aboutMe: string | null;
  photoUrl: string | null;
}

interface Props {
  produtor: FarmerInfo;
}

export default function ProdutorCard({ produtor }: Props) {
  //   const [produtorName, setProdutorName] = React.useState("");
  //   React.useEffect(() => {
  //     if (produtor.name) {
  //       const truncate = (str: string, n: number) => {
  //         return str.length > n ? str.substr(0, n - 1) + "..." : str;
  //       };
  //       setProdutorName(truncate(produtor.name, 18));
  //     }
  //     // return () => {}
  //   }, [produtor.name]);

  const ref = React.useRef<HTMLDivElement | null>(null);

  const [photoHeight, setphotoHeight] = React.useState(0);
  React.useLayoutEffect(() => {
    if (ref.current) {
      setphotoHeight(ref.current.offsetWidth);
    }
  }, [setphotoHeight]);

  const [produtorPhoto, setProdutorPhoto] = React.useState("");
  React.useEffect(() => {
    if (produtor.photoUrl) {
      setProdutorPhoto(produtor.photoUrl);
    }
  }, [produtor.photoUrl]);

  return (
    <div ref={ref}>
      <Card>
        <CardActionArea component={RouterLink} to={`farmer/${produtor.docId}`}>
          {produtorPhoto && (
            <CardMedia
              component="img"
              height={photoHeight}
              image={produtorPhoto}
              alt="Foto do produtor rural cooperado COOPASV"
            />
          )}
          <CardContent>
            <Typography variant="subtitle2" align="center" noWrap>
              {produtor.name}
              {/* {produtorName} */}
            </Typography>
          </CardContent>
        </CardActionArea>
      </Card>
    </div>
    //   <CardActionArea component={RouterLink} to={`farmer/${produtor.docId}`}>
    //     <Card sx={{ display: "flex" }}>
    //       {produtorPhoto && (
    //         <CardMedia
    //           component="img"
    //           sx={{
    //             width: 200,
    //             height: 228,
    //             display: { xs: "none", sm: "block" },
    //           }}
    //           image={produtorPhoto}
    //           alt="Foto do produtor"
    //         />
    //       )}

    //       <CardContent sx={{ flex: 1 }}>
    //         <Typography component="h2" variant="h5">
    //           {produtor.name}
    //         </Typography>
    //         {produtor.aboutMe ? (
    //           <Typography variant="subtitle1" paragraph>
    //             {produtorAboutMe}
    //           </Typography>
    //         ) : (
    //           <React.Fragment>
    //             <Typography variant="subtitle1">.</Typography>
    //             <Typography variant="subtitle1">.</Typography>
    //             <Typography variant="subtitle1">.</Typography>
    //             <Typography variant="subtitle1">.</Typography>
    //             <Typography variant="subtitle1">.</Typography>
    //           </React.Fragment>
    //         )}

    //         <Typography variant="subtitle1" color="primary">
    //           {produtor.aboutMe && "Continue lendo..."}
    //         </Typography>
    //       </CardContent>
    //     </Card>
    //   </CardActionArea>
  );
}
